import { useAppDispatch, useAppSelector } from "hooks";
import React, { useEffect } from "react";
import { nsoFlowFetchData, nsoFlowFetchNsoRequestData } from "../../../../redux/nsoFlow/nsoFlowSlice";
import CommonLoader from "components/CommonLoader";

type GetInlineAccessoryFromPcpsProps = {
  id: any;
};

function GetInlineAccessoryFromPcpsComponent({ id }: GetInlineAccessoryFromPcpsProps) {
  // eslint-disable-next-line sonarjs/no-duplicate-string
  const nsoSelectorData = useAppSelector((state) => state.nsoFlow.nsoFlow.data[5].data);
  const nsoSelectorNSOData = useAppSelector((state) => state.nsoFlow.nsoFlow.data[0].data);
  const [nsoSelector, setNsoSelector] = React.useState<any>(nsoSelectorData);

  const nsoError = useAppSelector((state) => state.errorStep.nsoError);
  const isError = nsoError ? nsoError.step >= 7 : false;
  const isAlreadyFetched =
    nsoSelectorData instanceof Array
      ? false
      : "status" in nsoSelectorData
        ? true
        : nsoSelectorData.flow_dtl_id === Number(id);

  const dispatch = useAppDispatch();
  useEffect(() => {
    if (!isError && !isAlreadyFetched) {
      dispatch(nsoFlowFetchData());
      dispatch(nsoFlowFetchNsoRequestData({ id, stepId: 7 }));
    } else {
      setNsoSelector(nsoSelectorData);
    }
  }, [dispatch, id, isAlreadyFetched, isError, nsoSelectorData]);

  const nsoSelectorLoading = useAppSelector((state) => state.nsoFlow.nsoFlow.loading);
  const RequestedConfiguration: Array<any> = [
    {
      id: 1,
      name: "Model Code ",
      value: nsoSelector.request_json?.modelCode ?? "",
    },
    {
      id: 2,
      name: "Model Year",
      value: nsoSelector.request_json?.modelYear ?? "",
    },
    {
      id: 3,
      name: "Original VDC",
      value: nsoSelector.request_json?.originalVDC ?? "",
    },
    {
      id: 4,
      name: "Factory",
      value: nsoSelectorNSOData?.request_json?.factoryOptions?.split(",").join(", ") || "",
    },
    {
      id: 5,
      name: "PPO",
      value: nsoSelectorNSOData?.request_json?.ppoOptions?.split(",").join(", ") || "",
    },
  ];

  // const InlineAccessoryFromPcpsData: Array<any> = [
  //   {
  //     id:1,
  //     value: nsoSelector.response_json?.ILAArray?.map((item: any) => item.ilaAccessoryCode).join(", ") ?? "",
  //     name: "ILA",
  //   }

  // const accessoryData: Array<any> = [
  //   {
  //     id: 1,
  //     name: "Valid ILA",
  //     value: nsoSelector.request_json?.requestId ?? "",
  //   },
  // ];

  const renderData: Array<any> = [
    {
      id: 1,
      title: "Requested Configuration",
      data: RequestedConfiguration,
    },
  ];

  if (nsoSelectorLoading) {
    return <CommonLoader active={nsoSelectorLoading} />;
  }
  return (
    <>
      <div className="border border-gray-300 rounded-lg shadow-lg gap-4">
        {renderData.map((item) => {
          return (
            <div className="w-full bg-gray-100 rounded-lg py-2 m-2" key={item.id}>
              <div className="flex w-full justify-start items-center content-center">
                <span className="font-bold mx-4 text-xl">{item.title}</span>
              </div>
              <div className="border border-gray-300 rounded-lg my-2 mx-0"></div>
              <div className="grid grid-cols-3 m-4 gap-4">
                {item.data.map((items: any) => (
                  <div className="" key={items.id}>
                    <div className="bg-yellow grid grid-cols-2 m-2 gap-4">
                      <div className="text-base">{items.name}</div>
                      {item.name === "Factory" || item.name === "PPO" ? (
                        <div className="text-base"></div>
                      ) : (
                        <div className="text-base">{items.value}</div>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          );
        })}
        <div className="w-full bg-gray-100 rounded-lg py-2 m-2">
          <div className="flex w-full justify-start items-center content-center">
            <span className="font-bold mx-4 text-xl">Inline Accessory From Pcps</span>
          </div>
          <div className="border border-gray-300 rounded-lg my-2 mx-0"></div>
          <div className="grid grid-cols-1 m-4 gap-4">
            {nsoSelector.response_json?.ILAArray &&
              nsoSelector.response_json?.ILAArray.map((item: any) => (
                <div className="grid-cols-2 grid" key={item.ilaAccessoryCode}>
                  <div className="bg-yellow grid grid-cols-2 m-2 gap-4">
                    <div className="text-base">Accessory Code</div>
                    <div className="text-base">{item?.ilaAccessoryCode}</div>
                  </div>
                  <div className="bg-yellow grid grid-cols-2 m-2 gap-4">
                    <div className="text-base">Spec Position | Spec Code</div>
                    <div className="text-base">
                      {item.specCode[0]?.slice(0, -1) || ""} |{" "}
                      {item.specCode[0]?.charAt(item.specCode[0]?.length - 1) || ""}
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </div>
        <div className="w-full bg-gray-100 rounded-lg py-2 m-2">
          <div className="flex w-full justify-start items-center content-center">
            <span className="font-bold mx-4 text-xl">Confirmed ILA</span>
          </div>
          <div className="border border-gray-300 rounded-lg my-2 mx-0"></div>
          <div className="grid grid-cols-3 m-4 gap-4">
            <div className="">
              <div className="bg-yellow grid grid-cols-2 m-2 gap-4">
                <div className="text-base">Valid ILA</div>
                <div className="text-base">
                  {nsoSelector.request_json?.validIlaDetails?.map((item: any) => item.accessoryCode).join(", ")}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default GetInlineAccessoryFromPcpsComponent;
